import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFietsenberging = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.43153 6.66675H12.9167V4.66675L7.9853 4.66675L6.21483 10.0335C6.03392 10.0113 5.85091 10 5.66675 10C5.37538 10 5.08693 10.0283 4.80505 10.0833H4.58329V10.1324C3.79553 10.3278 3.06827 10.7345 2.48477 11.318C1.64085 12.1619 1.16675 13.3065 1.16675 14.5C1.16675 15.6935 1.64086 16.8381 2.48477 17.682C3.32868 18.5259 4.47327 19 5.66675 19C6.86022 19 8.00482 18.5259 8.84873 17.682C9.69264 16.8381 10.1667 15.6935 10.1667 14.5C10.1667 13.6371 9.91894 12.7999 9.46273 12.0833H12.7874C12.3312 12.7999 12.0834 13.6372 12.0834 14.5C12.0834 15.6935 12.5575 16.8381 13.4014 17.682C14.2453 18.5259 15.3899 19 16.5834 19C17.7768 19 18.9214 18.5259 19.7654 17.682C20.6093 16.8381 21.0834 15.6935 21.0834 14.5C21.0834 13.3065 20.6093 12.1619 19.7654 11.318C18.9214 10.4741 17.7768 10 16.5834 10C16.292 10 16.0036 10.0283 15.7217 10.0833L8.30443 10.0833L9.43153 6.66675ZM5.53862 12.0833H5.02693C4.60387 12.1953 4.21377 12.4174 3.89898 12.7322C3.43014 13.2011 3.16675 13.837 3.16675 14.5C3.16675 15.163 3.43014 15.7989 3.89898 16.2678C4.36782 16.7366 5.00371 17 5.66675 17C6.32979 17 6.96567 16.7366 7.43451 16.2678C7.90336 15.7989 8.16675 15.163 8.16675 14.5C8.16675 13.837 7.90336 13.2011 7.43451 12.7322L7.43153 12.7292L6.67812 15.013L4.7788 14.3865L5.53862 12.0833ZM15.9436 12.0833H17.2232C17.6462 12.1953 18.0363 12.4174 18.3511 12.7322C18.82 13.2011 19.0834 13.837 19.0834 14.5C19.0834 15.163 18.82 15.7989 18.3511 16.2678C17.8823 16.7366 17.2464 17 16.5834 17C15.9203 17 15.2844 16.7366 14.8156 16.2678C14.3468 15.7989 14.0834 15.163 14.0834 14.5C14.0834 13.837 14.3468 13.2011 14.8156 12.7322C15.1304 12.4174 15.5205 12.1953 15.9436 12.0833Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFietsenberging);

export default ForwardRef;
